module.exports = {"120103001":"大营门街道","120103002":"下瓦房街道","120103003":"桃园街道","120103004":"挂甲寺街道","120103005":"马场街道","120103006":"越秀路街道","120103007":"友谊路街道","120103008":"天塔街道","120103009":"尖山街道","120103010":"陈塘庄街道","120103011":"柳林街道","120103012":"东海街道","120103013":"梅江街道","120103014":"太湖路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120103.json
// module id = 42
// module chunks = 0